/**
 * Standup day numbering, shared by the server gate and both client screens.
 *
 * Days are ISO day numbers: Monday = 1 through Sunday = 7. That is what
 * Postgres ISODOW returns, so the stored set compares directly against the
 * database. dayjs counts Sunday as 0, so this module is the one place the two
 * schemes are reconciled — do the conversion anywhere else and Sunday silently
 * becomes Monday.
 */
export const DEFAULT_CHECKIN_DAYS = [1, 2, 3, 4, 5];

export function isoDayOfWeekFromJsDay(jsDay: number): number {
  return jsDay === 0 ? 7 : jsDay;
}

/** "12:00 PM": the standup reminder hour, as the Standups settings page shows it. */
export function fmtReminderHour(hour: number) {
  const suffix = hour < 12 ? 'AM' : 'PM';
  const displayHour = hour % 12 === 0 ? 12 : hour % 12;
  return `${displayHour}:00 ${suffix}`;
}

export function isCheckinDayIso(isoDay: number, days: number[]): boolean {
  return days.includes(isoDay);
}

/**
 * A clean, ordered day set. An empty set would leave the grid's column walk
 * scanning backwards forever, so it falls back to Monday-Friday — the same
 * thing the column default does for every course that never sets this.
 */
export function sortedCheckinDays(days?: number[] | null): number[] {
  const valid = [...new Set(days || [])].filter((d) => Number.isInteger(d) && d >= 1 && d <= 7);
  return valid.length ? valid.sort((a, b) => a - b) : [...DEFAULT_CHECKIN_DAYS];
}
